import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { AuthShell } from "./ManagerLogin";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err, "Could not send reset email"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Reset Password" subtitle="We'll email you a reset link">
      {sent ? (
        <div className="text-center" data-testid="forgot-password-sent">
          <MailCheck className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
          <p className="text-slate-700 text-sm">
            If <span className="text-terra-600">{email}</span> is registered, a reset link is on its way. It expires in 1 hour.
          </p>
          <Link to="/login" className="inline-block mt-6 text-sm text-terra-600 hover:underline" data-testid="back-to-login-link">
            Back to login
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your manager email"
            data-testid="forgot-password-email-input"
            className="w-full h-12 px-4 rounded-xl bg-[#FAF6F0] border border-[#E4DDD3] text-[#1A1D20] placeholder-slate-400 focus:outline-none focus:border-terra-400/60"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="forgot-password-submit-button"
            className="w-full h-12 rounded-xl bg-terra-500 text-white font-display font-bold text-lg hover:bg-terra-600 disabled:opacity-50 transition-colors"
          >
            {busy ? "Sending…" : "Email Reset Link"}
          </button>
          <div className="text-sm text-slate-500 text-center">
            <Link to="/login" className="text-terra-600 hover:underline" data-testid="forgot-back-to-login-link">
              Back to login
            </Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
